import * as React from "react";
import type { SVGProps } from "react";
const SvgShieldOff = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#shield-off_svg__a)">
      <path
        fill="currentColor"
        d="M18.735 13.704a1 1 0 0 0 1.91.592zM20 12l1 .007V12zm0-7h1a1 1 0 0 0-.649-.936zm-8-3 .351-.936a1 1 0 0 0-.7 0zm-3.51.243a1 1 0 0 0 .7 1.874zM5.077 5.668a1 1 0 1 0-.694-1.876zM4 5l-.347-.938A1 1 0 0 0 3 5zm8 17-.447.894a1 1 0 0 0 .914-.01zm6.364-3.711a1 1 0 0 0-1.488-1.338zM1.707.293A1 1 0 0 0 .293 1.707zm20.586 23.414a1 1 0 0 0 1.414-1.414zm-1.648-9.41a7.9 7.9 0 0 0 .355-2.29l-2-.014a5.9 5.9 0 0 1-.265 1.71zM21 12V5h-2v7zm-.649-7.936-8-3-.702 1.872 8 3zm-8.7-3-3.16 1.18.699 1.873 3.16-1.18zM4.382 3.791l-.73.27.694 1.876.73-.27zM3 5v7h2V5zm0 7c0 3.446 2.282 6.2 4.342 8.003a22.7 22.7 0 0 0 4.103 2.836l.098.05.006.004h.002l.001.001L12 22l.448-.894-.002-.001-.013-.007-.058-.03q-.08-.041-.234-.127a20.692 20.692 0 0 1-3.482-2.444C6.719 16.8 5 14.554 5 12zm9.467 10.884a21.3 21.3 0 0 0 5.897-4.595l-1.488-1.338a19.3 19.3 0 0 1-5.343 4.165zM.293 1.707l22 22 1.414-1.414-22-22z"
      />
    </g>
    <defs>
      <clipPath id="shield-off_svg__a">
        <path
          fill="#fff"
          d="M0 0h24v24H0z"
        />
      </clipPath>
    </defs>
  </svg>
);
export default SvgShieldOff;
